import { useEffect, useRef } from 'react'

import { Routes } from 'common/constants'
import { logBridgeError } from 'common'
import { sendScreenView, toSnakeCase } from 'common/helpers'
import type { TEntity } from 'contexts/app-context/types'

export type TUseScreenFinishLoadTacParams = {
  name: string
  screen: Routes
  action: string
  entity: TEntity | undefined
  shouldSend: boolean
  logLabel: string
  customParams?: Record<string, string>
}

/**
 * Envia um único screen_view quando `shouldSend` for verdadeiro.
 */
export function useScreenFinishLoadTac({
  name,
  screen,
  action,
  entity,
  shouldSend,
  logLabel,
  customParams,
}: TUseScreenFinishLoadTacParams): void {
  const sentRef = useRef(false)

  useEffect(() => {
    if (!shouldSend || sentRef.current) return

    sentRef.current = true

    const run = async () => {
      try {
        await sendScreenView({
          flow: toSnakeCase(name),
          step: toSnakeCase(action),
          screen_name: screen,
          scenario: JSON.stringify({
            screen,
            product: entity,
            ...customParams,
          }),
        })
      } catch (error: unknown) {
        logBridgeError(logLabel, error)
        sentRef.current = false
      }
    }

    run()
  }, [shouldSend, name, screen, action, entity, logLabel, customParams])
}
